import { Component, OnInit } from "@angular/core";

@Component({
    selector: "dodo-typography-elements",
    templateUrl: "./typography-elements.component.html",
    styleUrls: ["./typography-elements.component.scss"],
    standalone: false
})
export class TypographyElementsComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
